module.exports = __webpack_public_path__ + "media/components/live/rdc/images/matching-buyers-1de4736f11ec152536f7675091e3078f.png";